export default __webpack_public_path__ + "static/media/es_hosarim.f59ad668.csv";